import React from "react";
import aboutImg from "../assets/about.jpg.avif";

const AboutSection = () => {
  return (
    <>
      <style>{`
        .about-section {
          background: #dcf6c6;
          padding: 80px 20px;
        }

        .about-container {
          max-width: 1200px;
          margin: auto;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 80px;
        }

        /* ✅ IMAGE UPDATED */
        .about-image img {
          width: 100%;
          max-width: 420px; /* increased width */
          height: 420px; /* fixed height */
          object-fit: cover; /* maintain proper crop */
          border-radius: 0; /* removed rounded corners */
          box-shadow: 0 12px 30px rgba(0,0,0,0.1);
        }

        .about-content {
          max-width: 550px;
        }

        .about-content h2 {
          font-size: 38px;
          font-weight: 700;
          color: #0F3D2E;
          margin-bottom: 20px;
          line-height: 1.3;
        }

        .about-content p {
          font-size: 16px;
          color: #555;
          margin-bottom: 25px;
          line-height: 1.6;
        }

        .about-list {
          list-style: none;
          padding: 0;
          margin-bottom: 30px;
        }

        .about-list li {
          display: flex;
          align-items: center;
          gap: 10px;
          margin-bottom: 12px;
          color: #333;
          font-size: 15px;
        }

        .check {
          width: 18px;
          height: 18px;
          background: #27AE60;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 12px;
        }

        .about-btn {
          background: #7ED957;
          color: black;
          padding: 12px 22px;
          border: none;
          border-radius: 999px;
          font-weight: 500;
          cursor: pointer;
          transition: 0.3s;
        }

        .about-btn:hover {
          background: #D4AF37;
        }

        .star {
          position: absolute;
          right: 80px;
          bottom: 40px;
          font-size: 80px;
          color: #7ED957;
          opacity: 0.4;
        }

        /* RESPONSIVE */
        @media (max-width: 900px) {
          .about-container {
            flex-direction: column;
            text-align: center;
          }

          .about-content {
            max-width: 100%;
          }

          .about-content h2 {
            font-size: 28px;
          }

          .about-image img {
            max-width: 100%;
            height: auto; /* responsive fix */
          }

          .about-list li {
            justify-content: center;
          }

          .star {
            display: none;
          }
        }
      `}</style>

      <section className="about-section">
        <div className="about-container">

          {/* IMAGE */}
          <div className="about-image">
            <img src={aboutImg} alt="Tax Services" />
          </div>

          {/* CONTENT */}
          <div className="about-content">
            <h2>
              Your Trusted Tax & Compliance Partner for
              Businesses and Individuals.
            </h2>

            <p>
              We provide complete financial solutions including ITR filing,
              GST compliance, TDS management, and accounting services.
              Our goal is to simplify taxation and help you stay fully compliant
              while maximizing savings.
            </p>

            <ul className="about-list">
              <li><span className="check">✓</span> ITR Filing for Salaried, Professionals & Businesses</li>
              <li><span className="check">✓</span> GST Filing, Registration & Compliance</li>
              <li><span className="check">✓</span> TDS / TCS Returns & Monthly Monitoring</li>
              <li><span className="check">✓</span> Bookkeeping & Accounting Services</li>
            </ul>

          </div>
        </div>

        <div className="star">*</div>
      </section>
    </>
  );
};

export default AboutSection;